import React, { useEffect, useCallback, useState } from 'react';
import {
  Button,
  CircularProgress,
  TextField,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  ClickAwayListener,
  Input,
  ListItem,
  List,
} from '@material-ui/core';

import { debounce, truncate } from 'lodash';
// Icon
import Icon from '@mdi/react';

import { Field, Formik } from 'formik';
import {
  MuiPickersUtilsProvider,
  DatePicker,
  TimePicker,
  DateTimePicker,
} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';
import {
  translateOrderStatus,
  convertPersianDigit2English,
  translateBundleStatus,
  translateUserRoles,
  translateSendDeliveryType,
  checkMatchMedia,
  translateCenterStatus,
  translateParcelsStatus,
  removeEmptyValueObject,
  flattenObject,
  translateFleetType,
  translateFleetStatus,
  translateDriversEmploymentStatus,
  translateVehicleType,
  translateTransactionType,
} from './helpers';
import { Status as OrderStatus } from '../pages/orders/interfaces';
import { Status as BundleStatus } from '../pages/bundles/interfaces';
import { Status as CenterStatus } from '../pages/centers/interfaces';
import { Status as ParcelsState } from '../pages/parcels/interfaces';
import { UserRole } from '../pages/users/interfaces';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Category } from '../pages/products/interfaces';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
        transition:
          'border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      },
      '& .MuiInput-underline::after': {
        borderBottom: '1px solid #d8d8d8 !important',
        transition:
          'border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        right: '0',
      },
      '& .MuiSelect-root': {
        fontSize: '1rem !important',
      },
      '&.MuiInputLabel-formControl': {
        top: '0',
        right: '0',
        position: 'absolute',
        transform: 'translate(0, 24px) scale(1)',
      },
    },
    textInput: {
      color: '#8a8a8a',
      '& input, .MuiSelect-root': {
        padding: '6px 0px 6px !important',
        width: '130px',
        transformOrigin: 'top left',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    inputWrapper: {
      flex: 7,
    },
    icon: {
      color: '#8a8a8a',
    },
  })
);

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });

export type State = {
  classes: Function;
};
export type Props = {
  filters: Filter[];
  onFilter: any; //ToDo
  setOpenFilterBox?: any;
};

export type Filter = {
  type:
  | 'input'
  | 'select'
  | 'checkbox'
  | 'date-picker'
  | 'number'
  | 'time-picker'
  | 'date-picker-time';
  id: string;
  label: string;
  placeholder?: string;
  data?:
  | OrderStatus[]
  | BundleStatus[]
  | UserRole[]
  | CenterStatus[]
  | ParcelsState[]
  | Category[];
  translateType?:
  | 'Order'
  | 'Category'
  | 'Bundle'
  | 'UserRole'
  | 'CenterStatus'
  | 'ParcelsStatus'
  | 'FleetType'
  | 'EmploymentStatus'
  | 'VehicleType'
  | 'TransactionType'
  | 'FleetStatus';
  icon?: any;
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class RenderFilters extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
    this.state = {
      checkboxValue: [],
      init: {},
      openBox: false,
    };
  }

  handleSubmit = (e: React.FormEvent<HTMLInputElement>) => {
    e.preventDefault();
  };
  handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    this.setState({ openBox: true });
    this.setState({
      checkboxValue: event.target.value,
    });
  };
  handleSelectAllClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    item: any
  ) => {
    if (event.target.checked) {
      const newSelecteds = item.data.map((n: any) => n);
      this.setState({ checkboxValue: newSelecteds });
      return;
    }
    this.setState({ checkboxValue: [] });
  };
  isSelected = (itemD: string) => this.state.checkboxValue.indexOf(itemD) > -1;
  handleClick = (event: React.MouseEvent<unknown>, itemD: string) => {
    const selectedIndex = this.state.checkboxValue.indexOf(itemD);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(this.state.checkboxValue, itemD);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(this.state.checkboxValue.slice(1));
    } else if (selectedIndex === this.state.checkboxValue.length - 1) {
      newSelected = newSelected.concat(this.state.checkboxValue.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        this.state.checkboxValue.slice(0, selectedIndex),
        this.state.checkboxValue.slice(selectedIndex + 1)
      );
    }
    this.setState({ checkboxValue: newSelected });
  };
  renderFromItems = (filters: Record<string, any>[], props: any) => {
    const [openCheckBox, setOpenCheckBox] = useState<boolean>(false);
    // useEffect(() => {
    //   const debouncer = debounce(() => {
    //     if (this.props.type.operator) {
    //       return this.props.onFilter({...props.values, ...props.filterVals});
    //     } else return null;
    //   }, 700);
    //   if (Object.keys(props.values).length > 0) {
    //     debouncer();
    //   }
    //   if (debouncer != undefined) {
    //     return () => debouncer.cancel();
    //   }
    // }, [props.values]);
    const classes = useStyles();
    return filters.map(
      (
        item: any, //todo type
        index: number
      ) => (
        <Grid
          className={classes.root}
          container
          item
          spacing={2}
          xs={12}
          sm={6}
          key={index}
        >
          {(item.type === 'input' ||
            item.type === 'number' ||
            item.type === 'date-picker' ||
            'date-picker-time' ||
            item.type === 'checkbox' ||
            (item.type === 'select' && item.icon)) &&
            item.icon && (
              <Grid
                item
                style={{
                  display: 'flex',
                  flex: 1,
                  alignItems: 'center',
                  marginTop: '10px',
                }}
              >
                <Icon path={item.icon} size={1} className={classes.icon} />
              </Grid>
            )}
          {item.type === 'input' && (
            <Grid item className={classes.inputWrapper}>
              <TextField
                name={item.id + `.${this.props.type.operator}`}
                label={item.label}
                fullWidth
                defaultValue={null}
                className={classes.textInput}
                value={
                  props.values[item.id + `.${this.props.type.operator}`] || null
                }
                onChange={props.handleChange}
              />
            </Grid>
          )}

          {item.type === 'number' && (
            <Grid item className={classes.inputWrapper}>
              <TextField
                name={item.id}
                label={item.label}
                type={item.type}
                className={classes.textInput}
                fullWidth
                value={props.values[item.id] || null}
                onChange={props.handleChange}
              />
            </Grid>
          )}

          {item.type === 'date-picker' && (
            <Grid item className={classes.inputWrapper}>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  fullWidth
                  autoOk
                  variant="inline"
                  label={item.label}
                  format="YYYY/MM/DD"
                  className={classes.textInput}
                  clearable
                  okLabel="تأیید"
                  cancelLabel="لغو"
                  clearLabel="پاک کردن"
                  labelFunc={date =>
                    date?.isValid() ? date.format('jYYYY/jMM/jDD') : ''
                  }
                  value={
                    props.values[item.id + `.${this.props.type.operator}`] ||
                    null
                  }
                  name={item.id}
                  id={item.id + `.${this.props.type.operator}`}
                  onChange={value => {
                    return props.setFieldValue(
                      [item.id + `.${this.props.type.operator}`],
                      value &&
                      convertPersianDigit2English(value.format('YYYY-MM-DD'))
                    );
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          )}
          {item.type === 'date-picker-time' && (
            <Grid item className={classes.inputWrapper}>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DateTimePicker
                  fullWidth
                  label={item.label}
                  variant="inline"
                  format="YYYY/MM/DD HH:mm"
                  className={classes.textInput}
                  autoOk
                  clearable
                  okLabel="تأیید"
                  cancelLabel="لغو"
                  clearLabel="پاک کردن"
                  labelFunc={date =>
                    date?.isValid() ? date.format('jYYYY/jMM/jDD HH:mm') : ''
                  }
                  value={props.values[item.id] || null}
                  name={item.id}
                  id={item.id}
                  onChange={value => {
                    return props.setFieldValue(
                      [item.id],
                      value && convertPersianDigit2English(value.format())
                    );
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          )}
          {item.type === 'time-picker' && (
            <Grid item className={classes.inputWrapper}>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <TimePicker
                  fullWidth
                  label={item.label}
                  variant="inline"
                  ampm={false}
                  format="HH:mm"
                  className={classes.textInput}
                  autoOk
                  clearable
                  labelFunc={date =>
                    date?.isValid() ? date.format('HH:mm') : ''
                  }
                  value={props.values[item.id] || null}
                  name={item.id}
                  id={item.id}
                  onChange={value => {
                    return props.setFieldValue(
                      [item.id],
                      value &&
                      convertPersianDigit2English(
                        value.format('jYYYY/jMM/jDD HH:mm')
                      )
                    );
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          )}
          {item.type === 'select' && (
            <Grid item className={classes.inputWrapper}>
              <FormControl style={{ width: '100%' }}>
                <InputLabel htmlFor={item.id}>{item.label}</InputLabel>
                <Select
                  fullWidth
                  className={classes.textInput}
                  name={item.id}
                  inputProps={{
                    name: item.id,
                    id: item.id,
                  }}
                  value={props.values[item.id]}
                  onChange={props.handleChange}
                >
                  {item.data.map((itemD: any, index: number) => (
                    <MenuItem value={itemD} key={index}>
                      {item.translateType === 'Order'
                        ? translateOrderStatus(itemD)
                        : item.translateType === 'UserRole'
                          ? translateUserRoles(itemD)
                          : item.translateType === 'ParcelsStatus'
                            ? translateParcelsStatus(itemD)
                            : item.translateType === 'FleetStatus'
                              ? translateFleetStatus(itemD)
                              : item.translateType === 'VehicleType'
                                ? translateVehicleType(itemD)
                                : item.translateType === 'TransactionType'
                                  ? translateTransactionType(itemD)
                                  : item.translateType === 'EmploymentStatus'
                                    ? translateDriversEmploymentStatus(itemD)
                                    : translateBundleStatus(itemD)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          {/* {item.type === 'checkbox' && (
          <Grid item className={classes.inputWrapper}>
            <ClickAwayListener
              onClickAway={() => {
                this.setState({openBox: false});
              }}
            >
              <TextField
                style={{marginTop: '4px'}}
                name={item.id + `.${this.props.type.operator}`}
                placeholder={item.label}
                fullWidth
                defaultValue={null}
                select
                multiline
                
                onClick={() => this.setState({openBox: !this.state.openBox})}
                SelectProps={{
                  open: this.state.openBox,
                  multiple:true,
                }}
                className={classes.textInput}
                // value={this.state.checkboxValue}
                value={(selected: any) => {
                  const nameSelectedItem = item.data.filter((status: any) => {
                    return selected.includes(status);
                  });

                  return nameSelectedItem
                    .map((nameSelect: any) =>
                      item.translateType === 'Order'
                        ? translateOrderStatus(nameSelect)
                        : item.translateType === 'UserRole'
                        ? translateUserRoles(nameSelect)
                        : item.translateType === 'Category'
                        ? nameSelect
                        : item.translateType === 'CenterStatus'
                        ? translateCenterStatus(nameSelect)
                        : item.translateType === 'ParcelsStatus'
                        ? translateParcelsStatus(nameSelect)
                        : item.translateType === 'FleetType'
                        ? translateFleetType(nameSelect)
                        : translateBundleStatus(nameSelect)
                    )
                    .join(',');
                }}
                onChange={e => {
                  this.handleChange(e);
                  props.handleChange(e);
                  setOpenCheckBox(false);
                }}
              >
                {item.data.map((itemD: any) => (
                  <MenuItem key={itemD} value={itemD}>
                    <Checkbox
                      checked={this.state.checkboxValue.indexOf(itemD) > -1}
                    />
                    <ListItemText
                      primary={
                        // Todo
                        item.translateType === 'Order'
                          ? translateOrderStatus(itemD)
                          : item.translateType === 'UserRole'
                          ? translateUserRoles(itemD)
                          : item.translateType === 'Category'
                          ? itemD
                          : item.translateType === 'CenterStatus'
                          ? translateCenterStatus(itemD)
                          : item.translateType === 'ParcelsStatus'
                          ? translateParcelsStatus(itemD)
                          : item.translateType === 'FleetType'
                          ? translateFleetType(itemD)
                          : translateBundleStatus(itemD)
                      }
                    />
                  </MenuItem>
                ))}
              </TextField>
            </ClickAwayListener>
          </Grid>
        )} */}

          {item.type === 'checkbox' && (
            <Grid
              item
              className={classes.inputWrapper}
              style={{ marginTop: '15px' }}
            >
              <FormControl style={{ width: '100%' }}>
                {/* <InputLabel id={item.id}>{item.label}</InputLabel> */}
                {/* {
                item.data.map((itemD:any,index2:number)=>{
                  const isItemSelected = this.isSelected(itemD);
                  return (
                    <List
                    component="nav"
                      name={item.id + `.${this.props.type.operator}`}
                      inputProps={{
                        name: item.id + `.${this.props.type.operator}`,
                        id: item.id,
                      }}
                    >
                      <ListItem>
                        <Checkbox
                          key={index2 + 5 * 123456}
                          onClick={event => this.handleClick(event, itemD)}
                          checked={isItemSelected}
                          inputProps={{
                            'aria-labelledby': `enhanced-table-checkbox-${item.id}`,
                          }}
                        />
                        <ListItemText>
                          {item.translateType === 'Order'
                            ? translateOrderStatus(itemD)
                            : item.translateType === 'UserRole'
                            ? translateUserRoles(itemD)
                            : item.translateType === 'Category'
                            ? itemD
                            : item.translateType === 'CenterStatus'
                            ? translateCenterStatus(itemD)
                            : item.translateType === 'ParcelsStatus'
                            ? translateParcelsStatus(itemD)
                            : item.translateType === 'FleetType'
                            ? translateFleetType(itemD)
                            : item.translateType === 'SendDeliveryType'
                            ? translateSendDeliveryType(itemD)
                            : translateBundleStatus(itemD)}
                        </ListItemText>
                      </ListItem>
                    </List>
                  );
                })
              } */}
                <Select
                  labelId={item.id}
                  id={item.id}
                  className={classes.textInput}
                  multiple
                  onChange={e => {
                    this.handleChange(e);
                    props.handleChange(e);
                  }}
                  open={this.state.openBox}
                  onClick={() => this.setState({ openBox: !this.state.openBox })}
                  value={this.state.checkboxValue}
                  input={<Input />}
                  name={item.id + `.${this.props.type.operator}`}
                  inputProps={{
                    name: item.id + `.${this.props.type.operator}`,
                    id: item.id,
                  }}
                  renderValue={(selected: any) => {
                    const nameSelectedItem = item.data.filter((status: any) => {
                      return selected.includes(status);
                    });

                    return nameSelectedItem
                      .map((nameSelect: any) =>
                        item.translateType === 'Order'
                          ? translateOrderStatus(nameSelect)
                          : item.translateType === 'UserRole'
                            ? translateUserRoles(nameSelect)
                            : item.translateType === 'Category'
                              ? nameSelect
                              : item.translateType === 'CenterStatus'
                                ? translateCenterStatus(nameSelect)
                                : item.translateType === 'VehicleType'
                                  ? translateVehicleType(nameSelect)
                                  : item.translateType === 'ParcelsStatus'
                                    ? translateParcelsStatus(nameSelect)
                                    : item.translateType === 'FleetType'
                                      ? translateFleetType(nameSelect)
                                      : translateBundleStatus(nameSelect)
                      )
                      .join(',');
                  }}
                  MenuProps={MenuProps}
                >
                  <MenuItem key={'itemD'} value={item.data}>
                    <Checkbox
                      indeterminate={
                        this.state.checkboxValue.length > 0 &&
                        this.state.checkboxValue.length < item.data.length
                      }
                      checked={
                        item.data.length > 0 &&
                        this.state.checkboxValue.length === item.data.length
                      }
                      onChange={e => this.handleSelectAllClick(e, item)}
                      inputProps={{ 'aria-label': 'select all desserts' }}
                    />
                    <ListItemText primary="انتخاب همه" />
                  </MenuItem>
                  {item.data.map((itemD: any) => (
                    <MenuItem key={itemD} value={itemD}>
                      <Checkbox
                        checked={this.state.checkboxValue.indexOf(itemD) > -1}
                      />
                      <ListItemText
                        primary={
                          // Todo
                          item.translateType === 'Order'
                            ? translateOrderStatus(itemD)
                            : item.translateType === 'UserRole'
                              ? translateUserRoles(itemD)
                              : item.translateType === 'Category'
                                ? itemD
                                : item.translateType === 'VehicleType'
                                  ? translateVehicleType(itemD)
                                  : item.translateType === 'CenterStatus'
                                    ? translateCenterStatus(itemD)
                                    : item.translateType === 'ParcelsStatus'
                                      ? translateParcelsStatus(itemD)
                                      : item.translateType === 'FleetType'
                                        ? translateFleetType(itemD)
                                        : item.translateType === 'SendDeliveryType'
                                          ? translateSendDeliveryType(itemD)
                                          : translateBundleStatus(itemD)
                        }
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* <div style={{padding: '0 5px'}}>
              <Button
                fullWidth
                variant="contained"
                size="large"
                onClick={() => {
                  this.setState({checkboxValue: item.data});
                  this.props.setOpenFilterBox &&
                    this.props.setOpenFilterBox(false);
                  setTimeout(
                    // Shet Code
                    () =>
                      this.props.setOpenFilterBox &&
                      this.props.setOpenFilterBox(true),
                    1000
                  );
                }}
              >
                {'انتخاب همه'}
              </Button>
            </div> */}
            </Grid>
          )}
        </Grid>
      )
    );
  };

  clearForm = (props?: any) => {
    this.setState({ checkboxValue: [] });
    this.props.onFilter({});
  };

  renderInitialValues = (items: Filter[]) => {
    const initialValues: any = {};
    items.map((filter: Filter) => (initialValues[filter.id] = null));
    this.setState({ init: initialValues });
  };

  render() {
    const { filters, onFilter } = this.props;
    return (
      //  <ClickAwayListener  onClickAway={()=>{this.setState({openBox:false}); debugger
      //  }} >
      <div>
        <Formik initialValues={this.state.init} onSubmit={onFilter}>
          {(props: {
            handleSubmit: any;
            values: any;
            handleReset: any;
            handleChange: any;
            resetForm: any;
            setValues: any;
          }) => {
            const formLength = Object.keys(
              removeEmptyValueObject(flattenObject(props.values))
            ).length;
            const primaryButton = {
              backgroundColor: formLength !== 0 ? '#dfa01f' : '#b3b3b3',
              color: 'white',
            };
            const secondaryButton = {
              backgroundColor: formLength !== 0 ? '#b3b3b3' : 'transparent',
              color: formLength !== 0 ? 'white' : '#c9c9c9',
              boxShadow: formLength !== 0 ? '' : 'none',
              whiteSpace: 'nowrap',
            };

            return (
              <form onSubmit={props.handleSubmit}>
                <Grid
                  container
                  spacing={checkMatchMedia('(max-width: 768px)') ? 1 : 3}
                >
                  {this.renderFromItems(filters, props)}
                  <Grid
                    xs={12}
                    sm={12}
                    item
                    style={{
                      display: 'flex',
                      marginTop: '20px',
                      marginBottom: '20px',
                      marginRight: 'auto',
                    }}
                  >
                    {/* <div style={{display: 'flex', flexGrow: 1}} /> */}

                    <div style={{ padding: '0 5px' }}>
                      <Button
                        fullWidth
                        variant="contained"
                        size="large"
                        style={secondaryButton}
                        disabled={formLength === 0}
                        onClick={() => {
                          onFilter({});
                          this.props.setOpenFilterBox &&
                            this.props.setOpenFilterBox(false);
                          setTimeout(
                            // Shet Code
                            () =>
                              this.props.setOpenFilterBox &&
                              this.props.setOpenFilterBox(true),
                            1000
                          );
                        }}
                      >
                        {'پاک ‌کردن همه '}
                      </Button>
                    </div>

                    <div style={{ padding: '0 5px' }}>
                      <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        size="large"
                        style={primaryButton}
                        data-cy="search"
                        disabled={formLength === 0}
                      >
                        {'جستجو'}
                        {false}
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </form>
            );
          }}
        </Formik>
      </div>
      //  </ClickAwayListener>
    );
  }
}

export default RenderFilters;
